export default __webpack_public_path__ + "static/media/pathwokring.0002eac9.jpg";